module.exports = __webpack_public_path__ + "static/img/shengluobo.3835988b.png";